import { shareEventInfoMessageOnReadForm as shareEventInfoMessageOnReadForm_1 } from 'owa-locstrings/lib/strings/shareeventinfomessageonreadform.locstring.json';
import {
    confirmReservationText as confirmReservationText_1,
    flightBusStopLabelText as flightBusStopLabelText_1,
    flightBusStopFirstLineFormatText as flightBusStopFirstLineFormatText_1,
    flightBusStopSummaryFormatText as flightBusStopSummaryFormatText_1,
    flightBusStopSummaryWithDurationFormatText as flightBusStopSummaryWithDurationFormatText_1,
    flightSummaryFirstLine as flightSummaryFirstLine_1,
    flightSummarySecondLine as flightSummarySecondLine_1,
    flightSummaryThirdLine as flightSummaryThirdLine_1,
    flightSummaryFourthLine as flightSummaryFourthLine_1,
    terminalText as terminalText_1,
    gateText as gateText_1,
    terminalGateText as terminalGateText_1,
    seatText as seatText_1,
    flightDepartureArrivalAriaText as flightDepartureArrivalAriaText_1,
    flightBusStopAriaText as flightBusStopAriaText_1,
    flightDepartureLabel as flightDepartureLabel_1,
    flightTerminalLabel as flightTerminalLabel_1,
    flightGateLabel as flightGateLabel_1,
    flightSeatLabel as flightSeatLabel_1,
    flightSeatText as flightSeatText_1,
    parcelDeliveryFirstLine as parcelDeliveryFirstLine_1,
    parcelDeliverySecondLine as parcelDeliverySecondLine_1,
    deliveryTextRange as deliveryTextRange_1,
    deliveryText as deliveryText_1,
    trackingText as trackingText_1,
    hotelCheckInText as hotelCheckInText_1,
    reservationText as reservationText_1,
    hotelCheckOutText as hotelCheckOutText_1,
    checkInSuffixText as checkInSuffixText_1,
    checkOutSuffixText as checkOutSuffixText_1,
    reservationCodeText as reservationCodeText_1,
    codeText as codeText_1,
    carText as carText_1,
    dropOffText as dropOffText_1,
    pickUpText as pickUpText_1,
    pickUpSuffixText as pickUpSuffixText_1,
    dropOffSuffixText as dropOffSuffixText_1,
    negativeTicketPopUpBodyText as negativeTicketPopUpBodyText_1,
    negativeTicketPopUpBodyHtmlText as negativeTicketPopUpBodyHtmlText_1,
    foundNewEventSingularText as foundNewEventSingularText_1,
    positiveFeedbackThanksText as positiveFeedbackThanksText_1,
    reservationProviderText as reservationProviderText_1,
    reservationPhoneText as reservationPhoneText_1,
    restaurantReservationPhoneText as restaurantReservationPhoneText_1,
    restaurantReservationWithOneGuestText as restaurantReservationWithOneGuestText_1,
    restaurantReservationWithGuestsText as restaurantReservationWithGuestsText_1,
    restaurantAriaFormatText as restaurantAriaFormatText_1,
    reservationForText as reservationForText_1,
    ticketNumberText as ticketNumberText_1,
    eventSectionSeatRowFormatText as eventSectionSeatRowFormatText_1,
    eventSeatRowFormatText as eventSeatRowFormatText_1,
    eventSeatText as eventSeatText_1,
    eventReservationWithOneGuestText as eventReservationWithOneGuestText_1,
    eventReservationWithGuestsText as eventReservationWithGuestsText_1,
    eventAriaFormatText as eventAriaFormatText_1,
    eventTimePrefixText as eventTimePrefixText_1,
    eventForPrefixText as eventForPrefixText_1,
    eventTicketLabel as eventTicketLabel_1,
    eventSeatPlaceholder as eventSeatPlaceholder_1,
    eventSeatRowPlaceholder as eventSeatRowPlaceholder_1,
    eventSectionRowSeatPlaceholder as eventSectionRowSeatPlaceholder_1,
    reservationLabelText as reservationLabelText_1,
    cityDateFormatText as cityDateFormatText_1,
    cardWithCitySummaryAriaText as cardWithCitySummaryAriaText_1,
    cardSummaryAriaText as cardSummaryAriaText_1,
    openEventAriaText as openEventAriaText_1,
    locationAriaText as locationAriaText_1,
    invoiceBillText as invoiceBillText_1,
    invoiceAccountNumberEndingInText as invoiceAccountNumberEndingInText_1,
    invoiceAccountNumberText as invoiceAccountNumberText_1,
    invoiceDueText as invoiceDueText_1,
    invoiceScheduledText as invoiceScheduledText_1,
    invoiceCustomerText as invoiceCustomerText_1,
    invoiceAmountText as invoiceAmountText_1,
    invoiceLabelText as invoiceLabelText_1,
    invoiceWithDueBusStopText as invoiceWithDueBusStopText_1,
    invoiceWithScheduledBusStopText as invoiceWithScheduledBusStopText_1,
    invoiceWithDueNoAmountBusStopText as invoiceWithDueNoAmountBusStopText_1,
    invoiceWithScheduledNoAmountBusStopText as invoiceWithScheduledNoAmountBusStopText_1,
    invoiceAriaWithDueFormatText as invoiceAriaWithDueFormatText_1,
    invoiceAriaWithScheduledFormatText as invoiceAriaWithScheduledFormatText_1,
    invoiceWithDueWholeCardSummaryText as invoiceWithDueWholeCardSummaryText_1,
    invoiceWithScheduledWholeCardSummaryText as invoiceWithScheduledWholeCardSummaryText_1,
    invoiceAriaWithDueNoAmountFormatText as invoiceAriaWithDueNoAmountFormatText_1,
    invoiceAriaWithScheduledNoAmountFormatText as invoiceAriaWithScheduledNoAmountFormatText_1,
    invoiceWithDueNoAmountWholeCardSummaryText as invoiceWithDueNoAmountWholeCardSummaryText_1,
    invoiceWithScheduledNoAmountWholeCardSummaryText as invoiceWithScheduledNoAmountWholeCardSummaryText_1,
    payBillButtonText as payBillButtonText_1,
    packageText as packageText_1,
    modifyReservationText as modifyReservationText_1,
    errorMessageItemNoLongerExist as errorMessageItemNoLongerExist_1,
    moreActionsText as moreActionsText_1,
    reservationHoldText as reservationHoldText_1,
    reservationPendingText as reservationPendingText_1,
    loadingErrorWithLinkPlaceholdersText as loadingErrorWithLinkPlaceholdersText_1,
    eventAutomaticallyAddedText as eventAutomaticallyAddedText_1,
    userVoiceFeedbackTextOnReadForm as userVoiceFeedbackTextOnReadForm_1,
    brandSummaryFlightSecondLineText as brandSummaryFlightSecondLineText_1,
    brandSummaryPackageSecondLineText as brandSummaryPackageSecondLineText_1,
    brandSummaryInvoiceFirstLineText as brandSummaryInvoiceFirstLineText_1,
    brandSummaryInvoiceSecondLineText as brandSummaryInvoiceSecondLineText_1,
    warningMessageForInvalidInput_0,
    placeHolderForHotelName as placeHolderForHotelName_1,
    placeHolderForLocation as placeHolderForLocation_1,
    placeHolderForServiceAppointmentTitle as placeHolderForServiceAppointmentTitle_1,
} from './createTxpStrings.locstring.json';
import { viewEmailText as viewEmailText_1 } from 'owa-locstrings/lib/strings/viewemailtext.locstring.json';
import {
    saveEventText as saveEventText_1,
    discardEventText as discardEventText_1,
    ErrorGeneralMessage as ErrorGeneralMessage_1,
    negativeTicketPopUpDonateEmailText as negativeTicketPopUpDonateEmailText_1,
    negativeTicketPopUpEmailUseText as negativeTicketPopUpEmailUseText_1,
    reservationStatusText as reservationStatusText_1,
    warningMessageForRequiredField_0,
    eventsLoadingText as eventsLoadingText_1,
    eventsLoadingErrorText as eventsLoadingErrorText_1,
    helpUsImproveText as helpUsImproveText_1,
    settingsSaveButtonText as settingsSaveButtonText_1,
    negativeTicketPopUpHeaderText as negativeTicketPopUpHeaderText_1,
    positiveTicketPopUpHeaderText as positiveTicketPopUpHeaderText_1,
    positiveTicketPopUpBodyText as positiveTicketPopUpBodyText_1,
    checkinText as checkinText_1,
    trackPackageButtonText as trackPackageButtonText_1,
    ErrorMessageRequestTimedOut as ErrorMessageRequestTimedOut_1,
    ErrorMessageServerUnavailable as ErrorMessageServerUnavailable_1,
    ErrorMessageFeatureNotEnabled as ErrorMessageFeatureNotEnabled_1,
    ErrorMessagePreviousEditInProgress as ErrorMessagePreviousEditInProgress_1,
    ErrorMessageNotLatestEmail as ErrorMessageNotLatestEmail_1,
    editEventText as editEventText_1,
    eventsFromEmailText as eventsFromEmailText_1,
    removeFromCalendarText as removeFromCalendarText_1,
    reportAnIssueText as reportAnIssueText_1,
    viewCalendarText as viewCalendarText_1,
    addToCalendarText as addToCalendarText_1,
    removeFromCalendarLoaderText as removeFromCalendarLoaderText_1,
    foundNewEventsText as foundNewEventsText_1,
    feedbackUsefulText as feedbackUsefulText_1,
    feedbackNotUsefulText as feedbackNotUsefulText_1,
    userVoiceFeedbackText as userVoiceFeedbackText_1,
    disclaimerText as disclaimerText_1,
    invoiceDisclaimerTextIntelligentTech as invoiceDisclaimerTextIntelligentTech_1,
    invoiceDisclaimerTextNotTrackingActivity as invoiceDisclaimerTextNotTrackingActivity_1,
} from '../../strings.locstring.json';
import { eventAddedTextOnReadForm as eventAddedTextOnReadForm_1 } from 'owa-locstrings/lib/strings/eventaddedtextonreadform.locstring.json';
import loc from 'owa-localize';

import createTxpStringFormatters from './createTxpStringFormatters';
import OwaTxpStringDefinitions from '../../store/schema/OwaTxpStringDefinitions';
import OwaCoreTxpStrings from 'owa-txp/lib/store/schema/OwaCoreTxpStrings';

export default function createTxpStrings(): OwaCoreTxpStrings {
    let txpStringDefinitions = {
        confirmReservationText: loc(confirmReservationText_1),
        disclaimerText: loc(disclaimerText_1),
        flightBusStopLabelText: loc(flightBusStopLabelText_1),
        flightBusStopFirstLineFormatText: loc(flightBusStopFirstLineFormatText_1),
        flightBusStopSummaryFormatText: loc(flightBusStopSummaryFormatText_1),
        flightBusStopSummaryWithDurationFormatText: loc(
            flightBusStopSummaryWithDurationFormatText_1
        ),
        flightSummaryFirstLine: loc(flightSummaryFirstLine_1),
        flightSummarySecondLine: loc(flightSummarySecondLine_1),
        flightSummaryThirdLine: loc(flightSummaryThirdLine_1),
        flightSummaryFourthLine: loc(flightSummaryFourthLine_1),
        terminalText: loc(terminalText_1),
        gateText: loc(gateText_1),
        terminalGateText: loc(terminalGateText_1),
        seatText: loc(seatText_1),
        flightDepartureArrivalAriaText: loc(flightDepartureArrivalAriaText_1),
        flightBusStopAriaText: loc(flightBusStopAriaText_1),
        flightDepartureLabel: loc(flightDepartureLabel_1),
        flightTerminalLabel: loc(flightTerminalLabel_1),
        flightGateLabel: loc(flightGateLabel_1),
        flightSeatLabel: loc(flightSeatLabel_1),
        flightSeatText: loc(flightSeatText_1),
        parcelDeliveryFirstLine: loc(parcelDeliveryFirstLine_1),
        parcelDeliverySecondLine: loc(parcelDeliverySecondLine_1),
        deliveryTextRange: loc(deliveryTextRange_1),
        deliveryText: loc(deliveryText_1),
        trackingText: loc(trackingText_1),
        hotelCheckInText: loc(hotelCheckInText_1),
        reservationText: loc(reservationText_1),
        hotelCheckOutText: loc(hotelCheckOutText_1),
        checkInSuffixText: loc(checkInSuffixText_1),
        checkOutSuffixText: loc(checkOutSuffixText_1),
        reservationCodeText: loc(reservationCodeText_1),
        codeText: loc(codeText_1),
        carText: loc(carText_1),
        dropOffText: loc(dropOffText_1),
        pickUpText: loc(pickUpText_1),
        pickUpSuffixText: loc(pickUpSuffixText_1),
        dropOffSuffixText: loc(dropOffSuffixText_1),
        reportAnIssueText: loc(reportAnIssueText_1),
        feedbackUsefulText: loc(feedbackUsefulText_1),
        feedbackNotUsefulText: loc(feedbackNotUsefulText_1),
        userVoiceFeedbackText: loc(userVoiceFeedbackText_1),
        positiveTicketPopUpBodyText: loc(positiveTicketPopUpBodyText_1),
        negativeTicketPopUpBodyText: loc(negativeTicketPopUpBodyText_1),
        negativeTicketPopUpBodyHtmlText: loc(negativeTicketPopUpBodyHtmlText_1),
        negativeTicketPopUpDonateEmailText: loc(negativeTicketPopUpDonateEmailText_1),
        negativeTicketPopUpEmailUseText: loc(negativeTicketPopUpEmailUseText_1),
        positiveTicketPopUpHeaderText: loc(positiveTicketPopUpHeaderText_1),
        negativeTicketPopUpHeaderText: loc(negativeTicketPopUpHeaderText_1),
        foundNewEventsText: loc(foundNewEventsText_1),
        foundNewEventSingularText: loc(foundNewEventSingularText_1),
        positiveFeedbackThanksText: loc(positiveFeedbackThanksText_1),
        reservationProviderText: loc(reservationProviderText_1),
        reservationPhoneText: loc(reservationPhoneText_1),
        restaurantReservationPhoneText: loc(restaurantReservationPhoneText_1),
        restaurantReservationWithOneGuestText: loc(restaurantReservationWithOneGuestText_1),
        restaurantReservationWithGuestsText: loc(restaurantReservationWithGuestsText_1),
        restaurantAriaFormatText: loc(restaurantAriaFormatText_1),
        reservationForText: loc(reservationForText_1),
        ticketNumberText: loc(ticketNumberText_1),
        eventSectionSeatRowFormatText: loc(eventSectionSeatRowFormatText_1),
        eventSeatRowFormatText: loc(eventSeatRowFormatText_1),
        eventSeatText: loc(eventSeatText_1),
        eventReservationWithOneGuestText: loc(eventReservationWithOneGuestText_1),
        eventReservationWithGuestsText: loc(eventReservationWithGuestsText_1),
        eventAriaFormatText: loc(eventAriaFormatText_1),
        eventTimePrefixText: loc(eventTimePrefixText_1),
        eventForPrefixText: loc(eventForPrefixText_1),
        eventTicketLabel: loc(eventTicketLabel_1),
        eventSeatPlaceholder: loc(eventSeatPlaceholder_1),
        eventSeatRowPlaceholder: loc(eventSeatRowPlaceholder_1),
        eventSectionRowSeatPlaceholder: loc(eventSectionRowSeatPlaceholder_1),
        reservationLabelText: loc(reservationLabelText_1),
        cityDateFormatText: loc(cityDateFormatText_1),
        cardWithCitySummaryAriaText: loc(cardWithCitySummaryAriaText_1),
        cardSummaryAriaText: loc(cardSummaryAriaText_1),
        openEventAriaText: loc(openEventAriaText_1),
        locationAriaText: loc(locationAriaText_1),
        invoiceBillText: loc(invoiceBillText_1),
        invoiceAccountNumberEndingInText: loc(invoiceAccountNumberEndingInText_1),
        invoiceAccountNumberText: loc(invoiceAccountNumberText_1),
        invoiceDueText: loc(invoiceDueText_1),
        invoiceScheduledText: loc(invoiceScheduledText_1),
        invoiceCustomerText: loc(invoiceCustomerText_1),
        invoiceAmountText: loc(invoiceAmountText_1),
        invoiceLabelText: loc(invoiceLabelText_1),
        invoiceWithDueBusStopText: loc(invoiceWithDueBusStopText_1),
        invoiceWithScheduledBusStopText: loc(invoiceWithScheduledBusStopText_1),
        invoiceWithDueNoAmountBusStopText: loc(invoiceWithDueNoAmountBusStopText_1),
        invoiceWithScheduledNoAmountBusStopText: loc(invoiceWithScheduledNoAmountBusStopText_1),
        invoiceAriaWithDueFormatText: loc(invoiceAriaWithDueFormatText_1),
        invoiceAriaWithScheduledFormatText: loc(invoiceAriaWithScheduledFormatText_1),
        invoiceWithDueWholeCardSummaryText: loc(invoiceWithDueWholeCardSummaryText_1),
        invoiceWithScheduledWholeCardSummaryText: loc(invoiceWithScheduledWholeCardSummaryText_1),
        invoiceAriaWithDueNoAmountFormatText: loc(invoiceAriaWithDueNoAmountFormatText_1),
        invoiceAriaWithScheduledNoAmountFormatText: loc(
            invoiceAriaWithScheduledNoAmountFormatText_1
        ),
        invoiceWithDueNoAmountWholeCardSummaryText: loc(
            invoiceWithDueNoAmountWholeCardSummaryText_1
        ),
        invoiceWithScheduledNoAmountWholeCardSummaryText: loc(
            invoiceWithScheduledNoAmountWholeCardSummaryText_1
        ),
        invoiceDisclaimerTextIntelligentTech: loc(invoiceDisclaimerTextIntelligentTech_1),
        invoiceDisclaimerTextNotTrackingActivity: loc(invoiceDisclaimerTextNotTrackingActivity_1),
        payBillButtonText: loc(payBillButtonText_1),
        trackPackageButtonText: loc(trackPackageButtonText_1),
        packageText: loc(packageText_1),
        modifyReservationText: loc(modifyReservationText_1),
        editEventText: loc(editEventText_1),
        saveEventText: loc(saveEventText_1),
        discardEventText: loc(discardEventText_1),
        checkinText: loc(checkinText_1),
        viewCalendarText: loc(viewCalendarText_1),
        viewEmailText: loc(viewEmailText_1),
        errorMessageItemNoLongerExist: loc(errorMessageItemNoLongerExist_1),
        addToCalendarText: loc(addToCalendarText_1),
        removeFromCalendarText: loc(removeFromCalendarText_1),
        moreActionsText: loc(moreActionsText_1),
        reservationStatusText: loc(reservationStatusText_1),
        reservationHoldText: loc(reservationHoldText_1),
        reservationPendingText: loc(reservationPendingText_1),
        eventsLoadingText: loc(eventsLoadingText_1),
        eventsLoadingErrorText: loc(eventsLoadingErrorText_1),
        helpUsImproveText: loc(helpUsImproveText_1),
        loadingErrorWithLinkPlaceholdersText: loc(loadingErrorWithLinkPlaceholdersText_1),
        eventsFromEmailText: loc(eventsFromEmailText_1),
        removeFromCalendarLoaderText: loc(removeFromCalendarLoaderText_1),
        eventAutomaticallyAddedText: loc(eventAutomaticallyAddedText_1),
        userVoiceFeedbackTextOnReadForm: loc(userVoiceFeedbackTextOnReadForm_1),
        shareEventInfoMessageOnReadForm: loc(shareEventInfoMessageOnReadForm_1),
        eventAddedTextOnReadForm: loc(eventAddedTextOnReadForm_1),
        brandSummaryFlightSecondLineText: loc(brandSummaryFlightSecondLineText_1),
        brandSummaryPackageSecondLineText: loc(brandSummaryPackageSecondLineText_1),
        brandSummaryInvoiceFirstLineText: loc(brandSummaryInvoiceFirstLineText_1),
        brandSummaryInvoiceSecondLineText: loc(brandSummaryInvoiceSecondLineText_1),
        warningMessageForInvalidInput: loc(warningMessageForInvalidInput_0),
        warningMessageForRequiredField: loc(warningMessageForRequiredField_0),
        placeHolderForHotelName: loc(placeHolderForHotelName_1),
        placeHolderForLocation: loc(placeHolderForLocation_1),
        placeHolderForServiceAppointmentTitle: loc(placeHolderForServiceAppointmentTitle_1),
        ErrorMessageRequestTimedOut: loc(ErrorMessageRequestTimedOut_1),
        ErrorMessageFeatureNotEnabled: loc(ErrorMessageFeatureNotEnabled_1),
        ErrorMessagePreviousEditInProgress: loc(ErrorMessagePreviousEditInProgress_1),
        ErrorMessageNotLatestEmail: loc(ErrorMessageNotLatestEmail_1),
        ErrorMessageServerUnavailable: loc(ErrorMessageServerUnavailable_1),
        ErrorGeneralMessage: loc(ErrorGeneralMessage_1),
        settingsSaveButtonText: loc(settingsSaveButtonText_1),
    } as OwaTxpStringDefinitions;

    const txpStrings: OwaCoreTxpStrings = {
        strings: txpStringDefinitions,
        formatters: createTxpStringFormatters(),
    };

    return txpStrings;
}
